import { addListener } from "@grindex-common/helpers/domManipulation";

import IframeBlockDomElements from "./iframeBlock.dom.elements";

function init($views) {
	$views.forEach(($view) => {
		const dom = new IframeBlockDomElements($view);

		var dynamicHeightOriginUrl = $view.dataset.origin;
		var messageEvent = $view.addEventListener ? "message" : "onmessage";

		var originUrl;
		if (dynamicHeightOriginUrl !== "") {
			originUrl = new URL(dynamicHeightOriginUrl);
			dynamicHeightOriginUrl = originUrl.origin;

			addListener(window, messageEvent, function (event) {
				const key = event.message ? "message" : "data";
				const data = event[key];

				if (event.origin === dynamicHeightOriginUrl) {
					const iframe = dom.iframe();
					const height = data + 1 + "px";
					iframe.height = height;
					iframe.style.height = height;
				}
			});
		}
	});
}
export default {
	view: "iframeBlock",
	init,
};
